/**
 * 播放列表页面相关接口
 */
import request from '@/utils/util.request';

/**
 * @desc: (playlist) 加载媒体列表
 * @param {date} _t
 * @param {int} limit
 * @param {int} offset
 * @param {string} type  "view" | "subtitle" | "audio" | "html"
 */
export const playlist_load_data = (data) => {
	return request({
		url: '/playlist/loaddata',
		data,
	});
};

/**
 * @desc: (playlist)点播单个媒体
 * @param {string} type 播放类型 "view" | "audio" | "html"
 * @param {} media_id 媒体ID
 */
export const play_item = (data) => {
	return request({
		url: '/playlist/playitem',
		data,
		loading: {
			text: '命令发送中...',
		},
	});
};

/**
 * @desc:  (playlist) 点播单个字幕
 * @param {string} type 播放类型 "subtitle"
 * @param {string | int} media_id 字幕ID
 */
export const play_subtitle = (data) => {
	return request({
		url: '/playlist/playsubtitle',
		data,
		loading: {
			text: '命令发送中...',
		},
	});
};

/**
 * @desc (playlist) 移除单个媒体/字幕
 * @param {int} id id
 * @param {string} type 播放类型 "view" | "subtitle" | "audio" | "html"
 */
export const playlist_remove_one = (data) => {
	return request({
		url: '/playlist/remove',
		data,
	});
};

/**
 * @desc: (playlist) 隐藏/展播单个媒体/字幕
 * @param {int} id 单个id
 * @param {string} type 播放类型
 * @param {int} on_show 是否展播 0 ｜ 1
 */
export const playlist_hide_show = (data) => {
	return request({
		url: '/playlist/hideshow',
		data,
	});
};
/**
 * @desc (playlist) 修改媒体属性
 * @param {int} id
 * @param {string} title 标题
 * @param {int} duration 时长
 * @param {int} order 播放顺序
 */
export const playlist_edit_view = (data) => {
	return request({
		url: '/playlist/editview',
		data,
	});
};

/**
 * @desc  (playlist) 修改音频属性
 * @param {int} id
 * @param {string} title 标题
 * @param {int} order 播放顺序
 */
export const playlist_edit_audio = (data) => {
	return request({
		url: '/playlist/editaudio',
		data,
	});
};

/**
 * @desc  (playlist) 修改字幕属性
 * @param {int} id
 * @param {string} subtitle 标题
 * @param {string} color 颜色
 * @param {int} order 播放顺序
 */
export const playlist_edit_subtitle = (data) => {
	return request({
		url: '/playlist/editsubtitle',
		data,
	});
};

/**
 * @desc  (playlist) 修改游戏属性
 * @param {int} id
 * @param {string} title 标题
 * @param {string} duration 时长
 * @param {int} order 播放顺序
 */
export const playlist_edit_html = (data) => {
	return request({
		url: '/playlist/edithtml',
		data,
	});
};

/**
 * @desc (playlist) 查看播放配置
 */
export const playlist_load_config = (data) => {
	return request({
		url: '/playlist/loadconfig',
		data,
	});
};

/**
 * @desc:  (playlist) 保存播放配置view
 * @param {int} picture_time 图片停留时间
 * @param {int} html_time html停留时间
 * @param {int} effect 转场效果
 * @param {int} picture_stretch 图片强制全屏 0 | 1
 * @param {int} video_stretch 视频强制全屏 0 | 1
 */
export const playlist_view_config = (data) => {
	return request({
		url: '/playlist/viewconfig',
		data,
	});
};

/**
 * @desc  (playlist) 保存播放配置audio
 * @param {} onoff 是否循环播放 0 ｜ 1
 */
export const playlist_audio_config = (data) => {
	return request({
		url: '/playlist/audioconfig',
		data,
	});
};

/**
 * @desc  (playlist) 保存播放配置subtitle
 * @param {int} onoff 是否循环播放
 * @param {int} speed 滚动速度
 * @param {string} location 显示位置  bottom | center | top
 * @param {int} size 字体大小
 */
export const playlist_subtitle_config = (data) => {
	return request({
		url: '/playlist/subtitleconfig',
		data,
	});
};
